import { TextField } from "@mui/material";
import React from "react";
import './style.scss';
const TextInput = ({
  name,
  label,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  inputProps,
  required,
  type,
}: any) => {
  return (
    <div className="textinput-css">
      {label ? (
        <div className="lg:text-[16px] text-[12px] lg:leading-[25px] leading-[18px] font-semibold text-text-color-1 pb-[10px]">
          {label}
        </div>
      ) : (
        ""
      )}
      <TextField
        name={name}
        fullWidth
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        helperText={helperText}
        inputProps={inputProps}
        required={required}
        type={type}
      />
    </div>
  );
};

export default TextInput;
